import { observer } from "mobx-react-lite"
import Layout from "../../components/layout/Layout"
import { Button, Flex, message, Popconfirm, Spin, Table, TableProps, Tabs, DatePicker, Image, Switch, Space } from "antd";
import { Project } from "../../stores/ProjectsStore";
import { RightOutlined, DownOutlined, UpOutlined, PlusOutlined, EditOutlined, DeleteOutlined, LeftOutlined } from '@ant-design/icons';
import { DateSort, TextSort } from "../../helpers/SorterHelper";
import { useStore } from "../../stores/root-store-context";
import { Roles } from "../../stores/EmployeesStore";
import { Link, useNavigate } from "react-router-dom";
import { useEffect, useState } from "react";
import TabPane from "antd/es/tabs/TabPane";
import dayjs, { Dayjs } from 'dayjs';
import duration from 'dayjs/plugin/duration';
import Breadcrumb from '../../components/layout/Breadcrumb';
import { TimeReport } from "../../api/TimeReportsApiClient";
import { Employee } from "../../api/EmployeesApiClient";
import { AddTimeReport } from "./AddTimeReport";
import { useTranslation } from "react-i18next";
import { EditTimeReport } from "./EditTimeReport";
import i18n from "../../i18n";
import { MyTime } from "./MyTime";
import { getUserComponent } from "../../helpers/user";
import { UsersTime } from "./UsersTime";
import { sumAllTime } from "../../helpers/timeReports";
import { ProjectsTime } from "./ProjectsTime";
import EventPage from "../Events/EventPage";
import CalendarEvents from "../Events/CalendarEvents";
import { CalendarEvent } from "../../api/EventsApiClient";
import UserTaskPage from "../UserTasks/UserTaskPage";
import { useLocation } from "react-router-dom";
import queryString from 'query-string'; 

dayjs.extend(duration);

const { RangePicker } = DatePicker;

const TimeReports = observer(() => {

    const { applicationStore, timeReportStore, employeesStore, projectsStore, eventStore } = useStore();
    const navigate = useNavigate();
    const { t } = useTranslation();
    const location = useLocation();

    const [isModalOpen, setIsModalOpen] = useState(false);
    const [activeTabKey, setActiveTabKey] = useState('my');

    useEffect(() => {
        const parsedQuery = queryString.parse(location.search);
        if (parsedQuery.tab) {
            setActiveTabKey(parsedQuery.tab as string);
        }
    }, [location.search]);

    const showModal = () => {
        setIsModalOpen(true);
    };

    const hideModal = () => {
        setIsModalOpen(false);
    };

    const [isModalOpenEdit, setIsModalOpenEdit] = useState(false);

    const showModalEdit = () => {
        setIsModalOpenEdit(true);
    };

    const hideModalEdit = () => {
        setIsChangeUser(true);
        setIsModalOpenEdit(false);
    };

    const [startDate, setStartDate] = useState<Dayjs>(dayjs().startOf("month"));
    const [endDate, setEndDate] = useState<Dayjs>(dayjs().endOf("month"));
    const [myTime, setMyTime] = useState<string>("00:00");


    const [expandedProject, setExpandedProject] = useState<string[]>([]);
    const onExpandProject = (expand: boolean, record: any) => {
        if (expand) {
            setExpandedProject(
                [
                    ...expandedProject,
                    record.key
                ]
            );
        } else {
            setExpandedProject(
                expandedProject.filter(a => a !== record.key)
            );
        }
    };
    const [editTimeReport, setEditTimeReport] = useState<TimeReport>();


    const [logUserId, setLogUserId] = useState<string>("");
    const [logProjectId, setLogProjectId] = useState<string>("");
    const [isChangeUser, setIsChangeUser] = useState<boolean>(true);

    const [timeByMe, setTimeByMe] = useState<any[]>([]);
    const [timeByUsers, setTimeByUsers] = useState<any[]>([]);
    const [timeByProjects, setTimeByProjects] = useState<any[]>([]);
    const [events, setEvents] = useState<any[]>([]);

    const getByUsers = () => {
        if (timeReportStore.reports) {
            let result = timeReportStore.reports.filter((el: any) => employeesStore.users.some(user => user.id === el.userId));
            result = result.filter((el: TimeReport) => el.startTime.isAfter(startDate, "day") && el.endTime.isBefore(endDate, "day"));
            const groupByUserId = (array: TimeReport[]) => {
                const grouped = array.reduce((acc: any, obj) => {
                    const { userId } = obj;
                    if (!acc[userId]) {
                        acc[userId] = { key: userId, user: employeesStore.users.find(user => user.id === userId), reports: [] };
                    }
                    acc[userId].reports.push(obj);
                    return acc;
                }, {});

                return Object.values(grouped);
            };
            const byUsers = groupByUserId(result);
            setTimeByUsers(byUsers);
        }
    }

    const getByMe = () => {
        if (timeReportStore.reports) {
            let result = timeReportStore.filterByUserId(applicationStore.user.id);
            result = result.filter((el: TimeReport) => el.startTime.isAfter(startDate, "day") && el.endTime.isBefore(endDate, "day"));
            setTimeByMe(result);
            setMyTime(sumAllTime(result));
        }
    }

    const getByProjects = () => {
        if (timeReportStore.reports) {
            let result = timeReportStore.reports.filter((el: any) => projectsStore.projects.some(proj => proj.id === el.projectId));
            result = result.filter((el: TimeReport) => el.startTime.isAfter(startDate, "day") && el.endTime.isBefore(endDate, "day"));
            const groupByProjectId = (array: TimeReport[]) => {
                const grouped = array.reduce((acc: any, obj) => {
                    const { projectId } = obj;
                    if (!acc[projectId]) {
                        acc[projectId] = { key: projectId, project: projectsStore.projects.find(item => item.id === projectId), reports: [] };

                    }
                    acc[projectId].reports.push(obj);
                    return acc;
                }, {});

                return Object.values(grouped);
            };
            const byProjects = groupByProjectId(result);
            setTimeByProjects(byProjects);
        }
    }

    const getEvents = () => {
        if (eventStore.events) {
            const events = eventStore.events.filter((el: CalendarEvent) => el.startDate.isAfter(startDate, "day") && el.endDate.isBefore(endDate, "day"));
            setEvents(events)
        }
    }

    const deleteTime = async (id: any) => {
        await timeReportStore.deleteById(id).then(() => {
            message.destroy("Deleting");
            message.success("The time was deleted");
        }).catch((error) => {
            message.error(error);
        })
    }

    useEffect(() => {
        employeesStore.getUsers().then(res => {
            projectsStore.getAll();
            timeReportStore.getAll();
            timeReportStore.getMyTime(applicationStore.user.id);
        })
    }, [])

    useEffect(() => {
        getByProjects();
        getByUsers();
        getByMe();
    }, [timeReportStore.reports, startDate, endDate])

    useEffect(() => {
        getEvents();
    }, [eventStore.events, startDate, endDate])

    const isChief = employeesStore.users.some(user => user.chiefId === applicationStore.user.id);

    return (
        <Layout headerStyle={1} footerStyle={2} breadcrumbTitle={"Time Reports"}>
            <div className="container" style={{ margin: "20px auto" }}>
                <Spin spinning={timeReportStore.isLoading}>
                    <Flex justify="end">
                        <Flex gap={5} align="baseline">
                            <Button shape="circle" onClick={(e) => {
                                setStartDate(startDate.subtract(1, "month").startOf("month"))
                                setEndDate(startDate.subtract(1, "month").endOf("month"))
                            }}>
                                <LeftOutlined />
                            </Button>
                            <RangePicker
                                value={[startDate, endDate]}
                                picker="date"
                                format="DD MMMM YYYY"
                                style={{ marginBottom: 16 }}
                                onChange={(dates: any) => {
                                    setStartDate(dates[0])
                                    setEndDate(dates[1])
                                }}
                            />
                            <Button shape="circle" onClick={(e) => {
                                setStartDate(startDate.add(1, "month").startOf("month"))
                                setEndDate(startDate.add(1, "month").endOf("month"))
                            }}>
                                <RightOutlined />
                            </Button>
                        </Flex>
                    </Flex>

                    <Tabs activeKey={activeTabKey}  onChange={(activeKey: string) => {
                        setActiveTabKey(activeKey);
                        switch (activeKey) {
                            case "my":
                                timeReportStore.getMyTime(applicationStore.user.id);
                                break;
                            case "allUsers":
                            case "allProjects":
                                timeReportStore.getAll();
                                break;
                            case "Events":
                            case "Calendar":
                                eventStore.getAll();
                                break;
                        }
                    }}>
                        <TabPane tab="My time" key="my">
                            <MyTime
                                setLogUserId={setLogUserId}
                                setLogProjectId={setLogProjectId}
                                showModalAdd={showModal}
                                showModalEdit={showModalEdit}
                                deleteTime={deleteTime}
                                setIsChangeUser={setIsChangeUser}
                                setEditTimeReport={setEditTimeReport}
                                timeReports={timeByMe}
                                myTimeStr={myTime} />
                        </TabPane>
                        <TabPane tab="By Users" key="allUsers">
                            <UsersTime
                                setLogUserId={setLogUserId}
                                setLogProjectId={setLogProjectId}
                                showModalAdd={showModal}
                                showModalEdit={showModalEdit}
                                deleteTime={deleteTime}
                                setIsChangeUser={setIsChangeUser}
                                setEditTimeReport={setEditTimeReport}
                                timeReports={timeByUsers}
                            />
                        </TabPane>
                        <TabPane tab="By Projects" key="allProjects">
                            <ProjectsTime
                                setLogUserId={setLogUserId}
                                setLogProjectId={setLogProjectId}
                                showModalAdd={showModal}
                                showModalEdit={showModalEdit}
                                deleteTime={deleteTime}
                                setIsChangeUser={setIsChangeUser}
                                setEditTimeReport={setEditTimeReport}
                                timeReports={timeByProjects}
                            />
                        </TabPane>
                        <TabPane tab="Events" key="Events">
                            <EventPage events={events} />
                        </TabPane>  
                        {isChief && (
                            <TabPane tab="Tasks" key="Tasks">
                                <UserTaskPage />
                            </TabPane>
                          )}
                        <TabPane tab="Calendar" key="Calendar">
                            <CalendarEvents events={events} startDate={startDate} endDate={endDate}/>
                        </TabPane>
                    </Tabs>

                </Spin>
            </div>

            <AddTimeReport isModalOpen={isModalOpen} hideModal={hideModal} projectId={logProjectId} userId={logUserId} isChangeUser={isChangeUser} />
            {editTimeReport &&
                <EditTimeReport isModalOpen={isModalOpenEdit} hideModal={hideModalEdit} id={editTimeReport?.id} time={editTimeReport?.totalTime} description={editTimeReport?.description} />
            }
        </Layout>
    )
})
export default TimeReports;